/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Commandmanp22Inputs */



/**
* | output |
* | --- |
* | "Manual command right/low pump" |
*
* @param {Br_History_Key_Commandmanp22Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_commandmanp22 = /** @type {((inputs?: Br_History_Key_Commandmanp22Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Commandmanp22Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Manual command right/low pump")
	return /** @type {LocalizedString} */ ("Commande manuelle pompe droite/basse")
});
export { br_history_key_commandmanp22 as "br_history_key_commandManP2" }